export default function PorQueConfiar() {
  const motivos = [
    {
      icone: 'ri-shield-check-line',
      titulo: 'Processo transparente',
      descricao: 'Todas as etapas documentadas e compartilhadas com total clareza',
    },
    {
      icone: 'ri-file-list-3-line',
      titulo: 'Contratos e governança',
      descricao: 'Documentação completa e estrutura jurídica sólida',
    },
    {
      icone: 'ri-camera-line',
      titulo: 'Acompanhamento de obra',
      descricao: 'Relatórios periódicos com fotos e vídeos do progresso',
    },
    {
      icone: 'ri-team-line',
      titulo: 'Time local na Flórida',
      descricao: 'Equipe experiente e presente em todas as etapas',
    },
    {
      icone: 'ri-star-line',
      titulo: 'Foco em qualidade',
      descricao: 'Acabamento premium e atenção aos detalhes',
    },
    {
      icone: 'ri-calendar-check-line',
      titulo: 'Compromisso com entrega',
      descricao: 'Prazos realistas e cumprimento rigoroso do cronograma',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">Por que confiar na Bravia</h2>
          <p className="text-xl text-gray-600">Compromisso com transparência e qualidade em cada projeto</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {motivos.map((motivo, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gold-500/10 flex items-center justify-center">
                <i className={`${motivo.icone} text-4xl text-black`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-3">{motivo.titulo}</h3>
              <p className="text-gray-600 leading-relaxed">{motivo.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
